import { useForm, ValidationError } from "@formspree/react";
import { useEffect, useState } from "react";
import TrustedFormCapture from "./TrustedFormCapture";

export default function NewsletterCTA() {
  const [state, handleSubmit] = useForm("mandyayr");
  const [pageSource, setPageSource] = useState("");
  useEffect(() => {
    setPageSource(window.location.href);
  }, []);

  return (
    <section className="mt-12 rounded-2xl border border-[#EADDC2] bg-[#FBF9F4] p-6 md:p-8">
      <div className="flex items-start gap-4">
        <span className="inline-grid h-10 w-10 place-items-center rounded-full bg-[#C89B3C] text-white">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22ZM20 17h-1V10a7 7 0 1 0-14 0v7H4a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2Z" />
          </svg>
        </span>

        <div className="w-full">
          <h3 className="text-xl md:text-2xl font-extrabold text-[#0A2540]">
            Sign Up For Our Newsletter
          </h3>
          <p className="mt-1 text-slate-700">
            Get new case updates, settlement deadlines, and breaking legal news
            straight to your inbox.
          </p>

          {state.succeeded ? (
            <div className="mt-4 rounded-lg bg-green-600/10 text-green-800 px-4 py-3">
              Thanks! You’re subscribed.
            </div>
          ) : (
            <form
              onSubmit={handleSubmit}
              className="mt-4 grid gap-3 sm:grid-cols-3"
            >
              <input
                className="rounded-lg border border-slate-300 px-3 py-2 outline-none focus:ring-2 focus:ring-[#C89B3C]"
                name="First name"
                placeholder="Enter your first name *"
                autoComplete="given-name"
                required
              />
              <input
                className="rounded-lg border border-slate-300 px-3 py-2 outline-none focus:ring-2 focus:ring-[#C89B3C]"
                name="Email"
                type="email"
                placeholder="Enter your email address *"
                autoComplete="email"
                required
              />

              <button
                type="submit"
                disabled={state.submitting}
                className="inline-flex items-center justify-center rounded-full px-5 py-3 font-semibold text-white
                           bg-[#C89B3C] hover:bg-[#B8872D] transition"
              >
                {state.submitting ? "Subscribing..." : "Subscribe"}
              </button>

              <input type="hidden" name="formType" value="newsletter" />
              <input type="hidden" name="Case type" value="Newsletter" />
              <input type="hidden" name="page source" value={pageSource} />

              {/* TF injector ONLY */}
              <TrustedFormCapture
                certField="trusteformcerturl"
                tokenField="trustedformtoken"
                pingField="trustedformpingurl"
              />

              <ValidationError
                prefix="Email"
                field="Email"
                errors={state.errors}
                className="sm:col-span-3 text-red-600"
              />
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
